import http from '@/api/http'
import config from '@/config'
import { ICredentials } from '@/utils/types'
import axios from 'axios'

const data = {
    // this is always the default API URL (depends on if production/development is selected)
    baseURL: config.$apiUrl,
    timeout: 45000,
    headers: {
        'Content-type': 'application/json'
    }
}
const loginHttp = axios.create(data);

export const login = (credentials: ICredentials) => {
    // update to the latest selected API url
    loginHttp.defaults.baseURL = config.$apiUrl;
    return loginHttp.post('/auth/login', credentials);
};
export const forgotPassword = (emailAddress: string) => http.post('/auth/forgotpassword', JSON.stringify(emailAddress))
export const resetPassword = (credentials: ICredentials) => {
    // update to the latest selected API url
    loginHttp.defaults.baseURL = config.$apiUrl;
    return loginHttp.post('/auth/resetpassword', credentials)
};
export const me = () => http.get('/auth/me');
